/**
 * c-rte-annotation.js
 *
 * 校正対応 2026-05-24 (商品詳細7 em + br 連続行間問題)
 *
 * 機能:
 *   rich_text 出力の <p> 要素のうち「em と br のみで構成 (= 意味のある text node なし)」
 *   の注釈段落のみを識別し、c-rte-annotation class を付与する。
 *   CSS .c-rte-annotation { line-height: 1 } で行間を縮める。
 *
 * 判定:
 *   p.childNodes を走査し、whitespace のみでない text node が無ければ注釈段落
 *
 * 対象:
 *   - .product__description p (Dawn 標準 商品本文)
 *   - .c-feature-row__content p (カスタム feature_row)
 *
 * 動的対応:
 *   MutationObserver で DOM 監視 → Dawn variant 切替 (section render API) で
 *   product__info が差替えられた際にも 新規 p に class 自動付与。
 */
(function () {
  var TARGET_SELECTORS = '.product__description p, .c-feature-row__content p';
  var CLASS_NAME = 'c-rte-annotation';

  function isAnnotationParagraph(p) {
    for (var i = 0; i < p.childNodes.length; i++) {
      var node = p.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
        return false; // 意味のある text node あり = 通常段落
      }
    }
    return true; // text node なし (or whitespace のみ) = 注釈段落
  }

  function applyAll() {
    var ps = document.querySelectorAll(TARGET_SELECTORS);
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.classList.contains(CLASS_NAME)) continue;
      if (isAnnotationParagraph(p)) {
        p.classList.add(CLASS_NAME);
      }
    }
  }

  function setup() {
    applyAll();
    if (window.MutationObserver && document.body) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        (window.requestAnimationFrame || setTimeout)(function () {
          scheduled = false;
          applyAll();
        }, 0);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
